import script from "./CreateWhatsappIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateWhatsappIntegration.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__